import {t} from "i18next";
import {all, call, put, takeLatest} from "redux-saga/effects";
import {fetchAllUsers as fetchAllUsersAPI} from "../../api/userManagement";
import {authFlowComplete} from "../features/authSlice";
import {setErrorNotification} from "../features/notificationsSlice";
import {
  fetchAllUsers,
  fetchAllUsersFailure,
  fetchAllUsersSuccess
} from "../features/usersSlice";

export function* fetchAllUsersSaga() {
  try {
    const users = yield call(fetchAllUsersAPI);
    yield put(fetchAllUsersSuccess(users));
  } catch (error) {
    console.error(error);
    yield put(fetchAllUsersFailure(error.data));
    yield put(setErrorNotification(t("incidents.assignees.loadingError")));
  }
}

export default function* usersSaga() {
  yield all([
    yield takeLatest([authFlowComplete, fetchAllUsers], fetchAllUsersSaga)
  ]);
}
